const JsonViewer = ({ data, title }) => {
  if (!data) return <p className="text-slate-500 italic">No configuration data available</p>;
  
  const renderValue = (value) => {
    if (value === null || value === undefined) return <span className="text-slate-500">null</span>;
    if (typeof value === 'boolean') return <span className="text-blue-400">{value.toString()}</span>;
    if (typeof value === 'number') return <span className="text-emerald-400">{value}</span>;
    if (typeof value === 'string') return <span className="text-slate-300">{value}</span>;
    if (Array.isArray(value)) {
      return (
        <div className="ml-4 border-l-2 border-slate-700 pl-3 space-y-1">
          {value.map((item, i) => (
            <div key={typeof item === 'object' && item !== null ? JSON.stringify(item).slice(0, 50) : `item-${i}`}>
              {typeof item === 'object' ? renderObject(item) : renderValue(item)}
            </div>
          ))}
        </div>
      );
    }
    if (typeof value === 'object') return renderObject(value);
    return <span className="text-slate-300">{String(value)}</span>;
  };

  const renderObject = (obj) => {
    if (!obj) return null;
    return (
      <div className="space-y-1">
        {Object.entries(obj).map(([key, value]) => (
          <div key={key} className="flex flex-wrap gap-1">
            <span className="text-[#2EC4B6] font-medium">{key}:</span>
            {renderValue(value)}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="bg-slate-900 rounded-lg p-4 text-xs font-mono overflow-x-auto max-h-64 overflow-y-auto">
      {title && <h4 className="text-[#2EC4B6] font-semibold mb-3 font-sans text-sm">{title}</h4>}
      {typeof data === 'object' ? renderObject(data) : renderValue(data)}
    </div>
  );
};

export default JsonViewer;
